import {useFormik} from 'formik'
import {FileInput, TextInput} from '../../../../_metronic/partials'
import React, {FC, MutableRefObject, useRef, useState} from 'react'
import {useStatusMessage} from '../../../features'
import * as Yup from 'yup'
import {Post} from '../../../../setup'
import {isAxiosError} from '../../../../setup/axios/requests'
import {useMailing} from '../../../@types'
import {useNotifications} from '../../../@contexts'

const initialValues = {
    name: '',
    file: null,
}


const Schema = Yup.object({
    name: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(100, 'Maximum 100 symbols')
        .required('Obligatoire'),
    file: Yup.mixed()
        .required('Le fichier est obligatoire'),
})


const IMPORT_LIST = process.env.REACT_APP_MAILING_LISTS_CONTACTS_IMPORT_CREATE || 'v2/list-contact'

interface ImportListInterface {
    closeRef: MutableRefObject<HTMLButtonElement | null>
}

const ImportList: FC<ImportListInterface> = ({closeRef}) => {

    const [filesCount, setFilesCount] = useState<number>(0)
    const fileInputRef = useRef<HTMLInputElement | null>(null)
    const {formState, setLoading} = useStatusMessage()
    const {triggerReload} = useMailing()
    const {setToast} = useNotifications()

    const onSubmit = async (values: any, {setSubmitting}: {
        setSubmitting: (isSubmitting: boolean) => void
    }) => {

        setLoading(true)

        try {
            const formData = new FormData()
            for (const [key, value] of Object.entries(values)) {
                if (value instanceof File) {
                    formData.append(key, value)
                } else if (typeof value === 'string' || typeof value === 'number') {
                    formData.append(key, value.toString())
                }
            }
            const {data} = await Post<any>(IMPORT_LIST, formData)
            if (data) {

                setToast({type: 'success', text: {title: 'Nouvelle liste', message: "Votre liste a été ajoutée avec succès."}})
                triggerReload()
                setTimeout(() => {
                    closeRef.current?.click()
                }, 2600)
            }

        } catch (err) {
            if (isAxiosError(err)) {

                const {name} = err.response?.data.errors
                if (name.length) {
                    setToast({type: 'error', text: {title: 'Nouvelle liste', message: "Le nom de la liste fournie existe déjà."}})
                }
            }
        } finally {
            setLoading(false)
            setSubmitting(false)
        }
    }

    const formik = useFormik({
        initialValues,
        validationSchema: Schema,
        enableReinitialize: true,
        onSubmit,
    })

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <div className="col-6">
                        <TextInput formik={formik} name={'name'} label={'Nom'} flex={'row'} />
                    </div>
                    <div className="col-12">
                        <FileInput fileInputRef={fileInputRef}
                                   filesCount={filesCount}
                                   setFilesCount={setFilesCount}
                                   formik={formik}
                                   description={'CSV, TXT ou RTF.'}
                                   accept={'.csv, .txt'}
                                   name={'file'}
                        />
                    </div>
                </div>
                <div className="text-end mt-5">
                    <button type="submit" className="btn btn-sm btn-primary me-2 px-6" disabled={formState.loading}>
                        {formState.loading ? (
                            <span className="indicator-progress d-block">
                  S'il vous plaît, attendez... <span
                                className="spinner-border spinner-border-sm align-middle ms-2" />
                </span>
                        ) : (
                            'Sauvegarder'
                        )}
                    </button>
                    <button type="button"
                            className="btn btn-sm btn-light me-2 px-6"
                            data-bs-dismiss="modal"
                            onClick={() => formik.resetForm()}
                            ref={closeRef}
                    >
                        Fermer
                    </button>
                </div>
            </form>
        </>
    )
}

export {ImportList}